import { render, staticRenderFns } from "./PaymentCombo.vue?vue&type=template&id=d01b5c40&"
import script from "./PaymentCombo.vue?vue&type=script&lang=js&"
export * from "./PaymentCombo.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCombo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports